import { createI18n } from 'vue-i18n'

// Import language files en, fr, es, eu, ca
import en from './src/locales/en.json'
import es from './src/locales/es.json'
import ca from './src/locales/ca.json'
import eu from './src/locales/eu.json'
import fr from './src/locales/fr.json'
import pt from './src/locales/pt.json'
// Error translations
import errorsEn from './src/locales/errors/en.json'
import errorsEs from './src/locales/errors/es.json'
import errorsFr from './src/locales/errors/fr.json'
// Shared, cross-cutting strings (toast headers, generic "close"/"loading"/…)
import commonEn from './src/locales/common/en.json'
import commonEs from './src/locales/common/es.json'
import commonFr from './src/locales/common/fr.json'
// Pages specific translations
import questionnaireEn from './src/locales/views/questionnarie/en.json'
import questionnaireEs from './src/locales/views/questionnarie/es.json'
import questionnaireFr from './src/locales/views/questionnarie/fr.json'
import dashboardEn from './src/locales/views/dashboard/en.json'
import dashboardEs from './src/locales/views/dashboard/es.json'
import dashboardFr from './src/locales/views/dashboard/fr.json'
import sessionResultsTestEn from './src/locales/views/sessionResultsTest/en.json'
import sessionResultsTestEs from './src/locales/views/sessionResultsTest/es.json'
import sessionResultsTestFr from './src/locales/views/sessionResultsTest/fr.json'
import sessionResultsV13En from './src/locales/views/sessionResultsV13/en.json'
import sessionResultsV13Es from './src/locales/views/sessionResultsV13/es.json'
import sessionResultsV13Fr from './src/locales/views/sessionResultsV13/fr.json'
import sessionResultsV14En from './src/locales/views/sessionResultsV14/en.json'
import sessionResultsV14Es from './src/locales/views/sessionResultsV14/es.json'
import sessionResultsV14Fr from './src/locales/views/sessionResultsV14/fr.json'
import sessionResultsSharedEn from './src/locales/views/sessionResults/en.json'
import sessionResultsSharedEs from './src/locales/views/sessionResults/es.json'
import sessionResultsSharedFr from './src/locales/views/sessionResults/fr.json'
import teamManagementEn from './src/locales/views/teamManagement/en.json'
import teamManagementEs from './src/locales/views/teamManagement/es.json'
import teamManagementFr from './src/locales/views/teamManagement/fr.json'
import signInEn from './src/locales/views/signIn/en.json'
import signInEs from './src/locales/views/signIn/es.json'
import signInFr from './src/locales/views/signIn/fr.json'
import organizationsEn from './src/locales/views/organizations/en.json'
import organizationsEs from './src/locales/views/organizations/es.json'
import organizationsFr from './src/locales/views/organizations/fr.json'
import teamsEn from './src/locales/views/teams/en.json'
import teamsEs from './src/locales/views/teams/es.json'
import teamsFr from './src/locales/views/teams/fr.json'
import historicalEn from './src/locales/views/historical/en.json'
import historicalEs from './src/locales/views/historical/es.json'
import historicalFr from './src/locales/views/historical/fr.json'
import consejosTpaEn from './src/locales/views/consejosTpa/en.json'
import consejosTpaEs from './src/locales/views/consejosTpa/es.json'
import consejosTpaFr from './src/locales/views/consejosTpa/fr.json'
import helpEn from './src/locales/views/help/en.json'
import helpEs from './src/locales/views/help/es.json'
import helpFr from './src/locales/views/help/fr.json'
import feedbackEn from './src/locales/views/feedback/en.json'
import feedbackEs from './src/locales/views/feedback/es.json'
import feedbackFr from './src/locales/views/feedback/fr.json'
import creditsEn from './src/locales/views/credits/en.json'
import creditsEs from './src/locales/views/credits/es.json'
import creditsFr from './src/locales/views/credits/fr.json'
import organizationHealthEn from './src/locales/views/organizationHealth/en.json'
import organizationHealthEs from './src/locales/views/organizationHealth/es.json'
import organizationHealthFr from './src/locales/views/organizationHealth/fr.json'
// Components specific translations
import tpiCardEn from './src/locales/components/TPICard/en.json'
import tpiCardEs from './src/locales/components/TPICard/es.json'
import tpiCardFr from './src/locales/components/TPICard/fr.json'
import teamStatsTablesEn from './src/locales/components/TeamStatsTables/en.json'
import teamStatsTablesEs from './src/locales/components/TeamStatsTables/es.json'
import teamStatsTablesFr from './src/locales/components/TeamStatsTables/fr.json'
import bulkAddMembersModalEn from './src/locales/components/BulkAddMembersModal/en.json'
import bulkAddMembersModalEs from './src/locales/components/BulkAddMembersModal/es.json'
import bulkAddMembersModalFr from './src/locales/components/BulkAddMembersModal/fr.json'
import nextStepsWorkflowEn from './src/locales/components/NextStepsWorkflow/en.json'
import nextStepsWorkflowEs from './src/locales/components/NextStepsWorkflow/es.json'
import nextStepsWorkflowFr from './src/locales/components/NextStepsWorkflow/fr.json'
import hptHighPerformanceAxesEn from './src/locales/components/HPTHighPerformanceAxes/en.json'
import hptHighPerformanceAxesEs from './src/locales/components/HPTHighPerformanceAxes/es.json'
import hptHighPerformanceAxesFr from './src/locales/components/HPTHighPerformanceAxes/fr.json'
import hptPerceptionGapEn from './src/locales/components/HPTPerceptionGap/en.json'
import hptPerceptionGapEs from './src/locales/components/HPTPerceptionGap/es.json'
import hptPerceptionGapFr from './src/locales/components/HPTPerceptionGap/fr.json'
import vertiacalEvolutionaryBarsCardEn from './src/locales/components/VertiacalEvolutionaryBarsCard/en.json'
import vertiacalEvolutionaryBarsCardEs from './src/locales/components/VertiacalEvolutionaryBarsCard/es.json'
import vertiacalEvolutionaryBarsCardFr from './src/locales/components/VertiacalEvolutionaryBarsCard/fr.json'
import multiDimensionalProfileEn from './src/locales/components/MultiDimensionalProfile/en.json'
import multiDimensionalProfileEs from './src/locales/components/MultiDimensionalProfile/es.json'
import multiDimensionalProfileFr from './src/locales/components/MultiDimensionalProfile/fr.json'
import teamUsersListEn from './src/locales/components/TeamUsersList/en.json'
import teamUsersListEs from './src/locales/components/TeamUsersList/es.json'
import teamUsersListFr from './src/locales/components/TeamUsersList/fr.json'
import organizationUsersListEn from './src/locales/components/OrganizationUsersList/en.json'
import organizationUsersListEs from './src/locales/components/OrganizationUsersList/es.json'
import organizationUsersListFr from './src/locales/components/OrganizationUsersList/fr.json'
import activeMembersCardEn from './src/locales/components/ActiveMembersCard/en.json'
import activeMembersCardEs from './src/locales/components/ActiveMembersCard/es.json'
import activeMembersCardFr from './src/locales/components/ActiveMembersCard/fr.json'
import questionnaireCompletionCountCardEn from './src/locales/components/QuestionnaireCompletionCountCard/en.json'
import questionnaireCompletionCountCardEs from './src/locales/components/QuestionnaireCompletionCountCard/es.json'
import questionnaireCompletionCountCardFr from './src/locales/components/QuestionnaireCompletionCountCard/fr.json'
import questionnaireSentCountCardEn from './src/locales/components/QuestionnaireSentCountCard/en.json'
import questionnaireSentCountCardEs from './src/locales/components/QuestionnaireSentCountCard/es.json'
import questionnaireSentCountCardFr from './src/locales/components/QuestionnaireSentCountCard/fr.json'
import sidebarEn from './src/locales/components/Sidebar/en.json'
import sidebarEs from './src/locales/components/Sidebar/es.json'
import sidebarFr from './src/locales/components/Sidebar/fr.json'
import replaceOrgLeaderModalEn from './src/locales/components/ReplaceOrgLeaderModal/en.json'
import replaceOrgLeaderModalEs from './src/locales/components/ReplaceOrgLeaderModal/es.json'
import replaceOrgLeaderModalFr from './src/locales/components/ReplaceOrgLeaderModal/fr.json'
import addOrgLeaderModalEn from './src/locales/components/AddOrgLeaderModal/en.json'
import addOrgLeaderModalEs from './src/locales/components/AddOrgLeaderModal/es.json'
import addOrgLeaderModalFr from './src/locales/components/AddOrgLeaderModal/fr.json'
import editUserModalEn from './src/locales/components/EditUserModal/en.json'
import editUserModalEs from './src/locales/components/EditUserModal/es.json'
import editUserModalFr from './src/locales/components/EditUserModal/fr.json'
import editTeamModalEn from './src/locales/components/EditTeamModal/en.json'
import editTeamModalEs from './src/locales/components/EditTeamModal/es.json'
import editTeamModalFr from './src/locales/components/EditTeamModal/fr.json'
import buyCreditsModalEn from './src/locales/components/BuyCreditsModal/en.json'
import buyCreditsModalEs from './src/locales/components/BuyCreditsModal/es.json'
import buyCreditsModalFr from './src/locales/components/BuyCreditsModal/fr.json'
import editCreditExpiryModalEn from './src/locales/components/EditCreditExpiryModal/en.json'
import editCreditExpiryModalEs from './src/locales/components/EditCreditExpiryModal/es.json'
import editCreditExpiryModalFr from './src/locales/components/EditCreditExpiryModal/fr.json'
import editOrganizationModalEn from './src/locales/components/EditOrganizationModal/en.json'
import editOrganizationModalEs from './src/locales/components/EditOrganizationModal/es.json'
import editOrganizationModalFr from './src/locales/components/EditOrganizationModal/fr.json'
import deleteUserModalEn from './src/locales/components/DeleteUserModal/en.json'
import deleteUserModalEs from './src/locales/components/DeleteUserModal/es.json'
import deleteUserModalFr from './src/locales/components/DeleteUserModal/fr.json'
import sessionSelectorEn from './src/locales/components/SessionSelector/en.json'
import sessionSelectorEs from './src/locales/components/SessionSelector/es.json'
import sessionSelectorFr from './src/locales/components/SessionSelector/fr.json'
import planEn from './src/locales/components/plan/en.json'
import planEs from './src/locales/components/plan/es.json'
import planFr from './src/locales/components/plan/fr.json'
import termsAndConditionsModalEn from './src/locales/components/TermsAndConditionsModal/en.json'
import termsAndConditionsModalEs from './src/locales/components/TermsAndConditionsModal/es.json'
import termsAndConditionsModalFr from './src/locales/components/TermsAndConditionsModal/fr.json'

const mergeDeep = (...objects: Record<string, any>[]): Record<string, any> =>
  objects.reduce((acc, obj) => {
    Object.keys(obj).forEach(key => {
      acc[key] =
        acc[key] && typeof acc[key] === 'object' && typeof obj[key] === 'object'
          ? mergeDeep(acc[key], obj[key])
          : obj[key]
    })
    return acc
  }, {})

const messages = {
  en: mergeDeep(
    en,
    errorsEn,
    commonEn,
    questionnaireEn,
    dashboardEn,
    sessionResultsTestEn,
    sessionResultsV13En,
    sessionResultsV14En,
    sessionResultsSharedEn,
    teamManagementEn,
    signInEn,
    organizationsEn,
    teamsEn,
    historicalEn,
    consejosTpaEn,
    helpEn,
    feedbackEn,
    creditsEn,
    organizationHealthEn,
    tpiCardEn,
    teamStatsTablesEn,
    bulkAddMembersModalEn,
    nextStepsWorkflowEn,
    hptHighPerformanceAxesEn,
    hptPerceptionGapEn,
    vertiacalEvolutionaryBarsCardEn,
    multiDimensionalProfileEn,
    teamUsersListEn,
    organizationUsersListEn,
    activeMembersCardEn,
    questionnaireCompletionCountCardEn,
    questionnaireSentCountCardEn,
    sidebarEn,
    replaceOrgLeaderModalEn,
    addOrgLeaderModalEn,
    editUserModalEn,
    editTeamModalEn,
    buyCreditsModalEn,
    editCreditExpiryModalEn,
    editOrganizationModalEn,
    deleteUserModalEn,
    sessionSelectorEn,
    planEn,
    termsAndConditionsModalEn
  ),
  es: mergeDeep(
    es,
    errorsEs,
    commonEs,
    questionnaireEs,
    dashboardEs,
    sessionResultsTestEs,
    sessionResultsV13Es,
    sessionResultsV14Es,
    sessionResultsSharedEs,
    teamManagementEs,
    signInEs,
    organizationsEs,
    teamsEs,
    historicalEs,
    consejosTpaEs,
    helpEs,
    feedbackEs,
    creditsEs,
    organizationHealthEs,
    tpiCardEs,
    teamStatsTablesEs,
    bulkAddMembersModalEs,
    nextStepsWorkflowEs,
    hptHighPerformanceAxesEs,
    hptPerceptionGapEs,
    vertiacalEvolutionaryBarsCardEs,
    multiDimensionalProfileEs,
    teamUsersListEs,
    organizationUsersListEs,
    activeMembersCardEs,
    questionnaireCompletionCountCardEs,
    questionnaireSentCountCardEs,
    sidebarEs,
    replaceOrgLeaderModalEs,
    addOrgLeaderModalEs,
    editUserModalEs,
    editTeamModalEs,
    buyCreditsModalEs,
    editCreditExpiryModalEs,
    editOrganizationModalEs,
    deleteUserModalEs,
    sessionSelectorEs,
    planEs,
    termsAndConditionsModalEs
  ),
  fr: mergeDeep(
    fr,
    errorsFr,
    commonFr,
    questionnaireFr,
    dashboardFr,
    sessionResultsTestFr,
    sessionResultsV13Fr,
    sessionResultsV14Fr,
    sessionResultsSharedFr,
    teamManagementFr,
    signInFr,
    organizationsFr,
    teamsFr,
    historicalFr,
    consejosTpaFr,
    helpFr,
    feedbackFr,
    creditsFr,
    organizationHealthFr,
    tpiCardFr,
    teamStatsTablesFr,
    bulkAddMembersModalFr,
    nextStepsWorkflowFr,
    hptHighPerformanceAxesFr,
    hptPerceptionGapFr,
    vertiacalEvolutionaryBarsCardFr,
    multiDimensionalProfileFr,
    teamUsersListFr,
    organizationUsersListFr,
    activeMembersCardFr,
    questionnaireCompletionCountCardFr,
    questionnaireSentCountCardFr,
    sidebarFr,
    replaceOrgLeaderModalFr,
    addOrgLeaderModalFr,
    editUserModalFr,
    editTeamModalFr,
    buyCreditsModalFr,
    editCreditExpiryModalFr,
    editOrganizationModalFr,
    deleteUserModalFr,
    sessionSelectorFr,
    planFr,
    termsAndConditionsModalFr
  ),
  ca,
  eu,
  pt,
}

const STORAGE_KEY = 'tpa_locale'
const supportedLocales = Object.keys(messages)

const getSavedLocale = (): string => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved && supportedLocales.includes(saved)) return saved
  } catch {
    // ignore
  }
  return 'es'
}

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  globalInjection: true, // Makes $t available in all templates without explicit useI18n()
  locale: getSavedLocale(),
  fallbackLocale: 'es', // set fallback locale
  messages, // set locale messages
})

const locale = i18n.global.locale.value
if (locale.includes('-')) {
  const shortLocale = locale.split('-')[0] as keyof typeof messages
  if (messages[shortLocale]) {
    i18n.global.locale.value = shortLocale
  }
}

/**
 * `t()` for code that runs outside a component's setup scope (router guards,
 * composables, services), where `useI18n()` is not available.
 *
 * Resolves against the live global instance on every call, so the result follows
 * the active locale (and, inside a `computed`, re-evaluates when it changes).
 *
 * It takes a plain string key on purpose: `i18n.global.t` is typed against this
 * whole catalogue, and TypeScript gives up on it (TS2589) at some call sites.
 */
export const tGlobal = (key: string, named?: Record<string, unknown>): string =>
  (i18n.global as unknown as { t: (key: string, named?: Record<string, unknown>) => string }).t(key, named)

export default i18n
